/* unplugin-vue-components disabled */import script from "./Showcase.vue?vue&type=script&lang=ts&setup=true"
export * from "./Showcase.vue?vue&type=script&lang=ts&setup=true"

import "./Showcase.vue?vue&type=style&index=0&id=197dc383&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197dc383"]])

export default __exports__